import { Injectable } from "@angular/core";
import { HoldingService } from "../http/business/holding/holding.service";

@Injectable({
  providedIn: "root"
})
export class BIDService {
  isOwner: boolean;
  constructor(private holdingService: HoldingService) {
    this.checkOwner();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }
  // BranchId
  setBID(data: string, name: string = null) {
    if (data != '0') {
      if (localStorage.getItem("branchCode") && this.isOwner) {
        if (data)
          localStorage.setItem("branchCode", data);
        if (name)
          localStorage.setItem("branchName", name);
      }

      if (!localStorage.getItem("branchCode")) {
        if (data)
          localStorage.setItem("branchCode", data);
        if (name)
          localStorage.setItem("branchName", name);
      }
    }
    else {
      localStorage.removeItem("branchCode");
      localStorage.removeItem("branchName");
    }



  }


  getBID() {
    return localStorage.getItem("branchCode");
  }
  getBName() {
    return localStorage.getItem("branchName");
  }

  removeBID() {
    localStorage.removeItem("branchCode");
    localStorage.removeItem("branchName");
  }
}
